import { bankDetailConstants } from "../../constants";

export function bankDetails(state = {}, action) {
  switch (action.type) {
    // get all
    case bankDetailConstants.GET_ALL_REQUEST:
      return {
        loading: true,
      };
    case bankDetailConstants.GET_ALL_SUCCESS:
      return {
        items: action.items,
      };
    case bankDetailConstants.GET_ALL_FAILURE:
      return {
        error: action.error,
      };

    // add
    case bankDetailConstants.ADD_REQUEST:
      return {
        loading: true,
      };
    case bankDetailConstants.ADD_SUCCESS:
      return {
        parameter: action.parameter,
      };
    case bankDetailConstants.ADD_FAILURE:
      return {
        error: action.error,
      };

    // update
    case bankDetailConstants.UPDATE_REQUEST:
      return {
        loading: true,
      };
    case bankDetailConstants.UPDATE_SUCCESS:
      return {
        parameter: action.parameter,
      };
    case bankDetailConstants.UPDATE_FAILURE:
      return {
        error: action.error,
      };

    // delete
    case bankDetailConstants.DELETE_REQUEST:
      return {
        loading: true,
      };
    case bankDetailConstants.DELETE_SUCCESS:
      return {
        parameter: action.parameter,
      };
    case bankDetailConstants.DELETE_FAILURE:
      return {
        error: action.error,
      };

    // clear
    case bankDetailConstants.CLEAR:
      return {};

    default:
      return state;
  }
}
